import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'scBranchDescription' })
export class BranchDescriptionPipe implements PipeTransform {

    constructor() { }

    transform(branch: string) {
        const conditionCase = parseInt(branch, 10) ? parseInt(branch, 10) : branch;

        return this.getInformation(conditionCase);
    }

    getInformation(branch) {
        let branchInformation: string;

        switch (branch) {
            case 1:
            case 'CA7CommAuto':
                branchInformation = 'AUTOMOTORES'
                break;
            case 2:
            case 'Fire':
                branchInformation = 'INCENDIO';
                break;
            case 3:
                branchInformation = 'CRISTALES';
                break;
            case 4:
            case 'Theft':
                branchInformation = 'ROBO';
                break;
            case 5:
                branchInformation = 'ACC. PERSONAS TRANSPORTADOS';
                break;
            case 6:
            case 'PersonalAccidents':
                branchInformation = 'ACCIDENTES PERSONALES';
                break;
            case 7:
            case 'Combined':
                branchInformation = 'COMBINADO';
                break;
            case 8:
                branchInformation = 'RIESGOS VARIOS';
                break;
            case 9:
                branchInformation = 'VIDA TEMPORARIO';
                break;
            case 10:
                branchInformation = 'AERONAVEGACION';
                break;
            case 11:
            case 'GeneralLiability_GLE':
                branchInformation = 'RESPONSABILIDAD CIVIL';
                break;
            case 12:
            case 'InlandMarine':
                branchInformation = 'TRANSPORTE';
                break;
            case 13:
                branchInformation = 'ACCIDENTES DE TRABAJO';
                break;
            case 14:
                branchInformation = 'GRANIZO';
                break;
            case 15:
            case 'Technical':
                branchInformation = 'SEGURO TECNICO';
                break;
            case 16:
            case 'Caution':
                branchInformation = 'CAUCION';
                break;
            case 17:
            case 'CollectiveLife':
            case 'Life':
                branchInformation = 'VIDA';
                break;
            case 18:
                branchInformation = 'SEGURO ESPECIAL AUTOMOTORES';
                break;
            case 50:
                branchInformation = 'PRENDARIO';
                break;
            case 52:
                branchInformation = 'PERSONALES';
                break;
            case 60:
                branchInformation = 'HIPOTECARIO - BIENES RAICES';
                break;
            case 61:
                branchInformation = 'HIPOTECARIO SAN CRISTOBAL SMSG';
                break;
            case 'AllRisk':
                branchInformation = 'TODO RIESGO OPERATIVO';
                break;
            case 'OtherRisk':
                branchInformation = 'OTROS RIESGOS';
                break;
            case 'HullAndAircraft':
                branchInformation = 'CASCO';
                break;
            case 'Agriculture':
                branchInformation = 'AGROPECUARIO';
                break;
            default:
                break;
        }
        return branchInformation
    }
}
